import React from "react";
import { Drawer, Image } from "antd";
import { FileOutlined } from "@ant-design/icons";
import "./styles.css";

export const DetailsField = ({ label, value }) => (
  <div className="details-drawer-row">
    <div className="details-drawer-label">{label}</div>
    <div className="details-drawer-value">{value || "\u2014"}</div>
  </div>
);

export const AttachmentPreview = ({ attachments }) => {
  if (!attachments || attachments.length === 0) {
    return <div className="details-drawer-value">{"\u2014"}</div>;
  }
  return (
    <div className="attachment-grid">
      {attachments.map((a) => {
        const isImage = /\.(jpg|jpeg|png|gif|webp|avif)$/i.test(a.file_name);
        return isImage ? (
          <Image
            key={a.id}
            src={a.file_url}
            alt={a.file_name}
            width={80}
            height={80}
            style={{
              objectFit: "cover",
              borderRadius: 4,
              border: "1px solid #e8e8e8",
            }}
            preview={{ mask: "View" }}
          />
        ) : (
          <a
            key={a.id}
            href={a.file_url}
            target="_blank"
            rel="noreferrer"
            className="attachment-file-link"
          >
            <FileOutlined style={{ marginRight: 4 }} />
            {a.file_name}
          </a>
        );
      })}
    </div>
  );
};

const DetailsDrawer = ({
  open,
  onClose,
  title = "Details",
  width = 350,
  children,
}) => {
  return (
    <Drawer
      title={title}
      placement="right"
      onClose={onClose}
      open={open}
      closable={false}
      className="details-drawer"
      headerStyle={{ backgroundColor: "#02475c", color: "#fff" }}
      bodyStyle={{ padding: "16px 24px" }}
      width={width}
    >
      <div className="details-drawer-close" onClick={onClose}>
        &times;
      </div>
      {children}
    </Drawer>
  );
};

export default DetailsDrawer;
